const CONTROL_ACCESO_REPORTS_LIST = (state, listpermiss) => {
  if (listpermiss.code === 1) {
    state.controlaccesoreports = listpermiss.data
    state.status = 'success'
  } else {
    alert(listpermiss.message)
    state.status = 'error'
  }
}

export default {
  CONTROL_ACCESO_REPORTS_LIST
}



// WEBPACK FOOTER //
// ./src/store/modules/controlacceso/reports/mutations.js